import type {
  Customer,
  GetCustomersParams,
  CreateCustomerDto,
  UpdateCustomerDto,
  ExportCustomersCriteria,
  CustomerStateHistory,
} from '../types/customers.types';

import apiClient from "../../../api/core/apiClient";

const BASE = '/crm/customers';

export const getCustomers = (params?: GetCustomersParams): Promise<Customer[]> =>
  apiClient.get<Customer[]>(BASE, params);

export const createCustomer = (data: CreateCustomerDto): Promise<Customer> =>
  apiClient.post<Customer>(BASE, data);

export const updateCustomer = (id: string, data: UpdateCustomerDto): Promise<Customer> =>
  apiClient.put<Customer>(`${BASE}/${id}`, data);

export const deleteCustomer = (id: string): Promise<void> =>
  apiClient.delete<void>(`${BASE}/${id}`);

export const exportCustomers = (criteria?: ExportCustomersCriteria): Promise<Blob> =>
  apiClient.download(`${BASE}/export`, criteria);

export const sendEmailTemplate = (template: string, criteria: any): Promise<any> =>
  apiClient.post<any>('/crm/email/template', { template, criteria });

export const changeCustomerState = (id: string, newStateId: string): Promise<any> =>
  apiClient.post<any>(`${BASE}/${id}/state`, { newStateId });

export const getCustomerStateHistory = (id: string, params?: { limit?: number; cursor?: string }): Promise<{ data: CustomerStateHistory[]; nextCursor: string | null }> =>
  apiClient.get<{ data: CustomerStateHistory[]; nextCursor: string | null }>(`${BASE}/${id}/state-history`, params);
